
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 47 47","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M22.5 1C10.073 1 0 11.074 0 23.498 0 35.926 10.073 46 22.5 46S45 35.926 45 23.498C45 11.074 34.927 1 22.5 1z","fill":"#4FA2B7"}}),_c('g',{attrs:{"transform":"translate(7 12)","fill":"#FFF"}},[_c('path',{attrs:{"d":"M2.798 4.131c-.775 0-1.407-.621-1.407-1.382 0-.763.632-1.382 1.407-1.382.778 0 1.407.619 1.407 1.382 0 .761-.63 1.382-1.407 1.382zm2.907 5.71c-1.31-.371-2.21-1.548-2.21-2.886V5.409c1.36-.345 2.327-1.666 2.057-3.158C5.354 1.146 4.456.254 3.332.048 1.556-.274 0 1.061 0 2.75c0 1.278.894 2.353 2.101 2.66v1.546c0 1.946 1.313 3.658 3.216 4.2l4.446 1.262v-1.423L5.705 9.842z"}}),_c('circle',{attrs:{"fill-rule":"nonzero","cx":"15.783","cy":"11","r":"5.261"}}),_c('path',{attrs:{"d":"M29.768 17.577v1.974c0 .098-.08.174-.174.174h-1.975a.175.175 0 01-.177-.174v-1.974c0-.095.08-.175.177-.175h1.975c.095 0 .174.08.174.175zm-.177 3.47H27.62a1.497 1.497 0 01-1.496-1.496v-1.974c0-.825.669-1.497 1.496-1.497h.328v-1.242a2.9 2.9 0 00-2.096-2.786L22 10.94V9.565l4.218 1.219a4.24 4.24 0 013.048 4.054v1.242h.328c.825 0 1.496.672 1.496 1.497v1.974c0 .825-.671 1.496-1.499 1.496z"}})])])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/pnFill.svg